module.exports = __webpack_public_path__ + "1390e3e73be1149f0960acfe4a0a4931.svg";